import React from 'react';

interface AddNewButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({ onClick, label = 'Add New', className = '', style }) => (
  <button
    onClick={onClick}
    className={`d-flex align-items-center justify-content-center gap-2` + (className ? ` ${className}` : '')}
    style={{
      fontFamily: 'Inter, Helvetica Neue, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '150%',
      letterSpacing: '0%',
      textAlign: 'center',
      minWidth: '107px',
      height: '36px',
      borderRadius: '10px',
      gap: '4px',
      paddingTop: '8px',
      paddingRight: '16px',
      paddingBottom: '8px',
      paddingLeft: '16px',
      background: '#2563eb',
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      transition: 'background 0.2s',
      whiteSpace: 'nowrap',
      ...style,
    }}
  >
    {label}
    <span style={{ fontSize: 20, fontWeight: 600, marginLeft: 4, display: 'inline-block', verticalAlign: 'middle', lineHeight: 1 }}>+</span>
  </button>
);

export default AddNewButton; 